module.exports = __webpack_public_path__ + "img/chassis.1d4d729d.jpg";